import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { GetLogsQueryDto, GetLogsResponse } from '@/@types/theoryGit/logs';

const VuexModule = createModule({
  namespaced: 'theoryGitLogsStore',
  strict: false,
});

export class LogsStore extends VuexModule {
  private readonly logsRepository = RepositoryFactory.theoryGit.logsRepository();
  /**state */
  private commitLogs: GetLogsResponse | null = null;

  @mutation
  private setCommitLogs(payload: GetLogsResponse) {
    this.commitLogs = payload;
  }

  @mutation
  private init(payload: null) {
    this.commitLogs = payload;
  }

  /**コミットログ一覧取得 */
  @action
  async fetchCommitLogs(params: {
    repositoryInfoId: number,
    query: GetLogsQueryDto,
  }) {
    const results = await this.logsRepository.getLogs(
      params.repositoryInfoId,
      params.query,
    );
    this.setCommitLogs(results);
  }

  @action
  async initState() {
    this.init(null);
  }

  get getCommitLogs() {
    return this.commitLogs;
  }
}
